import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const pushChannel = defineChannel({
  id: 'push',
  icon: 'mobile',
} as const satisfies ChannelDefinition);
